'use client';
import { jsx, jsxs } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { getTestLabels } from '../../../utils/getTestLabels.js';
import '../../Form/ButtonField/ButtonField.js';
import { Checkbox } from '../../Form/Checkbox/Checkbox.js';
import '../../Form/Field/Field.js';
import '../../Form/Fieldset/Fieldset.js';
import '../../Form/Fieldset/Legend.js';
import '../../Form/FileUpload/FileUpload.js';
import '../../Form/FormFieldProxy/ProxyInput.js';
import '../../Form/FormFieldProxy/ProxySelect.js';
import '../../Form/FormFieldProxy/ProxyTextarea.js';
import '../../Form/FormFieldWrap/FormFieldWrap.js';
import '../../Form/FormMessage/FormMessage.js';
import '../../Form/Input/Input.js';
import '../../Form/InputField/InputField.js';
import '../../Form/Label/Label.js';
import '../../Form/PhoneField/PhoneField.js';
import '../../Form/PinInput/PinInput.js';
import '../../Form/Radio/Radio.js';
import '../../Form/RadioCard/RadioCard.js';
import '../../Form/RadioCardGroup/RadioCardGroup.js';
import '../../Form/Select/Select.js';
import '../../Form/SelectField/SelectField.js';
import '../../Form/Slider/Slider/Slider.js';
import '../../Form/Slider/RangeSlider/RangeSlider.js';
import '../../Form/Textarea/Textarea.js';
import '../../Form/TextareaField/TextareaField.js';
import style from '../DropdownMenu/DropdownMenu.module.scss.js';

const { componentTestLabel, elementTestLabel } = getTestLabels('DropdownMenuCheckboxList');
/**
 * [source code](https://src.private.zooplus.net/projects/FE/repos/ui-components/browse/src/components/DropdownMenu/DropdownMenu.tsx)
 *
 * @param {DropdownMenuCheckboxListItemProps[]} items - An array of `DropdownMenuCheckboxListItemProps` items.
 * @param {function} onItemUpdate - Function to fire when a checkbox is toggled. Receives the associated `item` object. Use this function to update the `items` prop from an outside component.
 */
const DropdownMenuCheckboxList = forwardRef((props, ref) => {
    const { className, items, onItemUpdate, ...otherProps } = props;
    return (jsx("ul", { "data-zta": componentTestLabel, ref: ref, ...otherProps, className: classNames(style['z-dropdown-menu-checkbox-list'], className), children: items.map((item) => {
            const { id, isChecked, label, name, metaData, value } = item;
            return (jsxs("li", { "data-zta": elementTestLabel('Item'), children: [jsx(Checkbox, { "data-zta": elementTestLabel('Checkbox'), checked: isChecked, id: `dropdown-checkbox-id-${id.toString()}`, name: name, onChange: () => {
                            onItemUpdate(item);
                        }, value: value, children: label }), metaData && (jsx("div", { className: style['z-dropdown-menu-checkbox-list__meta'], "data-zta": elementTestLabel('Meta'), children: metaData }))] }, id));
        }) }));
});
DropdownMenuCheckboxList.displayName = 'DropdownMenuCheckboxList';

export { DropdownMenuCheckboxList };
//# sourceMappingURL=DropdownMenuCheckboxList.js.map
